<template>
  <div class="member" style="width: 100%" >
    <div class="member-head" >
      <div class="member-head-title">
        成员管理
      </div>
      <div class="member-head-content">
        <!-- 选择邀请成员 -->
        <a-row style="margin-top: 36px; display: flex; align-items: center">
          <a-col :span="3" class="member-input"><span style="color: red">*</span> 选择要邀请的成员：</a-col>
          <a-col :span="8" class="member-input">
            <a-select
              show-search
              placeholder="搜索加入项目的成员名称"
              style="width: 100%"
              v-if="depMemberList.length > 0"
              @change="handleDepMemberListChange"
            >
              <!-- <a-select-option value="jack"> Jack </a-select-option>
              <a-select-option value="lucy"> Lucy </a-select-option>
              <a-select-option value="tom"> Tom </a-select-option> -->
              <a-select-option 
                v-for="item in depMemberList" 
                :value="item.realname" 
                :key="item.id"
              >
                {{ item.realname }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="6" class="info" v-if="checkStatus">请选择成员！</a-col>
        </a-row>
        <!-- 选择项目权限 -->
        <a-row style="margin-top: 36px; display: flex; align-items: center">
          <a-col :span="3" class="member-input"><span style="color: red">*</span> 选择角色权限：</a-col>
          <a-col :span="8" class="member-input">
            <a-select show-search placeholder="普通成员" style="width: 100%" @change="handleTypeChange">
              <a-select-option value="1"> 管理员 </a-select-option>
              <a-select-option value="2"> 开发者 </a-select-option>
              <a-select-option value="3"> 访客 </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="6" class="info" v-if="checkStatus">请选择角色权限！</a-col>
        </a-row>
        <!-- 选择到期日 -->
        <a-row style="margin-top: 36px; display: flex; align-items: center">
          <a-col :span="3" class="member-input">访问到期日期：</a-col>
          <a-col :span="8" class="member-input">
            <a-date-picker style="width: 100%" @change="onChange" />
          </a-col>
        </a-row>
        <a-row style="margin-top: 20px; display: flex">
          <a-col :offset="3">
            <a-button type="primary" @click="addMember">添加成员</a-button>
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="member-content" >
      <div class="member-head-title">
        现有成员和团队
        <a-row style="width: 90%; height: 100%" class="member-table-head">
          <a-col :offset="12" :span="8"
            ><a-input-search
              placeholder="请输入查询的成员名字"
              style="width: 100%"
              @search="onSearch"
          /></a-col>
          <a-col :offset="1" :span="3">
            <a-select
              default-value="名字、升序"
              style="width: 120px"
              @change="handleNameOrderChange"
            >
              <a-select-option value="asc"> 名字、升序 </a-select-option>
              <a-select-option value="desc"> 名字、降序 </a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </div>
      <div class="member-table">
        <a-table :columns="columns" :data-source="memberList" :pagination="pagination" :loading="loading" @change="onPaginationChange">
          <a slot="name" slot-scope="text">{{ text }}</a>
          <template slot="avatar" slot-scope="text, record">
            <img
              class="card-bottom-right-img"
              :src="record.userAvatar || require('@/assets/avatar.png')"
            />
          </template>
          <template slot="action" slot-scope="text, record">
            <a-dropdown :trigger="['click']">
              <a class="ant-dropdown-link">
                编辑 <a-icon type="down" />
              </a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a @click="editRole(record,3)">仅查看</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="editRole(record,2)">可编辑</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="deleteMember(record.id)">移除</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>
<script>
import global_ from "@/utils/global.js";
import api from '@/request/api-manager/projectUser.js'
import _ from 'lodash'
const columns = [
  {
    title: "头像",
    dataIndex: "userAvatar",
    scopedSlots: { customRender: "avatar" },
    width: 150,
  },
  {
    title: "姓名",
    dataIndex: "userRealname",
    width: 150,
  },
  {
    title: "身份",
    dataIndex: "roleType",
    width: 600,
    align: "left",
  },
  {
    title: "操作",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
  },
];
export default {
  data() {
    return {
      data: [],
      columns,
      pagination:{
        current: 1,
        pageSize:10
      },
      projectId: '',
      memberList: [],
      loading: false,
      depMemberList: [],
      addParams: {
        sysUserId: '',
        roleType: ''
      },
      checkStatus: false
    };
  },
  props: {
    depId: String
  },
  mounted() {
    this.projectId = this.$route.query.projectId
    this.getTableDatas()
    this.getSelectOption()
  },
  methods: {
    getTableDatas(order = 'asc', userRealname = '') {
      this.loading = true
      this.pagination.pageNo =  this.pagination.current
      api.list({
        ...this.pagination,
        projectId: this.projectId,
        userRealname: `*${userRealname}*`,
        column: 'userUsername',
        order,
      }).then(res => {
        res.result.records.forEach((resp) => {
          resp.roleType = this.correspondingRelation(
            resp.roleType,
            global_.roleType
          );
        });
        this.memberList = res.result.records;
        this.pagination = {...this.pagination,total:res.result.total};
        console.log("this.pagination",this.pagination);
        this.loading = false
      })
    },
    onPaginationChange(pagination, filters, sorter, { currentDataSource }) {
        console.log(
            `pagination: `,
            pagination,
            "filters: ",
            filters,
            "sorter: ",
            sorter,
            "currentDataSource: ",
            currentDataSource
        );
        this.pagination = Object.assign(this.pagination, pagination);
        this.getTableDatas();
    },

    getSelectOption() {
      api.getAllUsr({
        pageSize: 10000
      }).then(res => {
        console.log(res,'resresresres');
        let depMemberList = _.unionBy( res.result.records, 'realname' )
        this.depMemberList = depMemberList.filter( item => item.realname != null )
      })
    },

    addMember() {
      if ( this.addParams.sysUserId == '' || this.addParams.roleType == '' ) {
        this.checkStatus = true
        return
      }
      console.log(this.addParams.sysUserId,'this.addParams.sysUserId');
      if (this.checkUniqueMember(this.addParams.sysUserId)) {
        this.$message.warning("成员已存在");
        return 
      }
      this.addParams.projectId = this.projectId
      api.addMember(this.addParams).then((res) => {
        if(res.success){
          this.$message.success("添加成功！");
          this.getTableDatas()
        }else{
          this.$message.error(res.message);
        }
      })
    },

    handleDepMemberListChange(val) {
      this.checkStatus = false
      this.addParams.sysUserId = this.depMemberList.filter( item => item.realname == val )[0].id
    },

    handleTypeChange(val) {
      this.checkStatus = false
      this.addParams.roleType = val
    },

    editRole(records,type) {
      let params = {
        ...records,
        roleType: type
      }
      api.editMember(params).then(() => {
        this.$message.success('修改成功')
      })
    },

    checkUniqueMember(id) {
      let uniqueStatus = false
      this.memberList.forEach(item => {
        if ( item.sysUserId == id ) {
          uniqueStatus = true
        }
      })
      return uniqueStatus
    },

    onSearch(value) {
      this.getTableDatas('asc',value)
    },

    onChange(date, dateString) {
      console.log(date, dateString);
    },

    handleNameOrderChange(value) {
      this.getTableDatas(value)
    },

    deleteMember(id){
      api.delMember({ id }).then(() => {
        this.$message.success('删除成功')
        this.getTableDatas()
      }).catch(() => {
        this.$message.error('删除失败')
      })
    }
  },
};
</script>
<style scoped>
@import "./index.response.css";
</style>